import { v4 as uuid } from 'uuid';

import { WEBCHAT_VISITOR_IDENTIFIER_PREFIX } from 'modules/webchat/domain/constants';
import {
  IWebchatIdentity,
  TWebchatVisitorType,
} from 'modules/webchat/domain/entities';

import formatPhoneToE164 from './formatPhoneToE164';

type TBuildVisitorWebchatIdentityParams = {
  name: string;
  phone: string;
  countryCode: string;
  type: TWebchatVisitorType;
};

/**
 * Identidade do visitante que passou pelo pré-chat. O identifier é aleatório
 * e fica salvo no navegador: a identificação do celular não devolve o id do
 * cadastro, para não expor dados de quem digitar o celular de outra pessoa.
 */
export default function buildVisitorWebchatIdentity({
  name,
  phone,
  countryCode,
  type,
}: TBuildVisitorWebchatIdentityParams): IWebchatIdentity {
  return {
    identifier: `${WEBCHAT_VISITOR_IDENTIFIER_PREFIX}${uuid()}`,
    name: name.trim(),
    phone: formatPhoneToE164(phone, countryCode),
    type,
  };
}
